module.exports = __webpack_public_path__ + "public/SiteIcons/mailDark.png?bde7ecb6";